import React, { useState, useEffect, useCallback } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, message } from 'antd';
import { useDispatch } from 'react-redux';
import {
  setConfig, setAdmin, setAuth
} from './redux/actions/common'
import * as Service from './core/Service';
import AppRoute from './AppRoute';

message.config({
  top: '75%',
  maxCount: 1,
});

const AppContainer = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const init = useCallback(async () => {
    let resp = await Service.call("get", "/api/config");

    if (resp && resp.status > 0) {
      dispatch(setConfig(resp));
    } else {
      throw new Error('failed to get app config');
    }
  }, [dispatch]);

  const checkAccess = () => {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/tnc"
    ) {
      return;
    }
    const wallet_address = localStorage.getItem("wallet_address");
    if (wallet_address === null) {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    setLoading(true);
    init();
    checkAccess();
    setLoading(false);
  }, [init]);

  if (loading) {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return (
      <div style={{position: 'absolute', top: '50%', left: '50%'}}>
        <Spin indicator={antIcon} />
      </div>
    );
  }

  return (
    <div>
      <AppRoute />
    </div>
  );
}

export default AppContainer;
